import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../Button/Button';
import styles from '../CreateParameterPopup.module.css';
import LabelParameters from '../LabelParameters';
const Url = ({ parameterData, handleChange, editingInput, setEditingInput }) => {
  const [t] = useTranslation("Contacts");

  return (
    <>
      <LabelParameters
        value={parameterData.url}
        text={"url"}
        editingInput={editingInput}
        setEditingInput={setEditingInput}
      >
        <div className={styles.urlContainer}>

          <input
            type="text"
            value={parameterData?.url}
            name={'number'}
            onChange={handleChange}
            placeholder='www.example.com'
          />
          <Button type='white' headerStyle={{ borderRadius: "999px" }}>{t('openInNewTab')}</Button>

        </div>
      </LabelParameters>
    </>
  )
}

export default Url